import React from 'react';
import PropTypes from 'prop-types';

import Frame from '../../img/certificate-frame.jpg';

const CertificatePreview = ({ studentName }) => (
  <div className="cert-preview" aria-hidden="true">
    <div className="cert-preview__sheet" style={{ backgroundImage: `url(${Frame})` }}>
      <div className="cert-preview__body">
        <span className="cert-preview__title">Сертифікат</span>
        <span className="cert-preview__small">цим підтверджується, що</span>
        <span className="cert-preview__name">{studentName || 'Прізвище і ім’я'}</span>
        <span className="cert-preview__small">успішно закінчив(ла)</span>
      </div>
      <span className="cert-preview__sign cert-preview__sign--left">директор</span>
      <span className="cert-preview__sign cert-preview__sign--right">дата видачі</span>
    </div>
  </div>
);

CertificatePreview.propTypes = {
  studentName: PropTypes.string,
};

CertificatePreview.defaultProps = {
  studentName: '',
};

export default CertificatePreview;
